module.exports = __webpack_public_path__ + "assets/img/CTA-cartoucherie-pdc_newcover-07-02-18.888588d6.jpg";